import React from "react"

import { FeedbackButton } from "./FeedbackButton"
import { useFeedbackButtonModel } from "./model/useFeedbackButtonModel"

export const FeedbackButtonConnector = React.memo(() => (
  <FeedbackButton {...useFeedbackButtonModel()} />
))
